import { useQuery } from "@tanstack/react-query";

export const useBrandSettings = () => {
  return useQuery({
    queryKey: ['brand-settings'],
    queryFn: async () => {
      try {
        const response = await fetch('/api/settings/brand');
        const result = await response.json();

        const defaultSettings = {
          store_name: 'المتجر',
          logo_url: '',
          favicon_url: '',
          primary_color: '#10b981',
          secondary_color: '#059669',
          accent_color: '#34d399',
          header_bg_color: '#10b981',
          header_text_color: '#ffffff',
          button_bg_color: '#10b981',
          button_text_color: '#ffffff',
          floating_cta_bg_color: '#ec4899',
          floating_cta_text_color: '#ffffff'
        };

        if (!response.ok) return defaultSettings;
        return result.data || defaultSettings;
      } catch (error) {
        console.error("Failed to fetch brand settings:", error);
        return {
          store_name: 'المتجر',
          logo_url: '',
          favicon_url: '',
          primary_color: '#10b981',
          secondary_color: '#059669',
          accent_color: '#34d399',
          header_bg_color: '#10b981',
          header_text_color: '#ffffff',
          button_bg_color: '#10b981',
          button_text_color: '#ffffff',
          floating_cta_bg_color: '#ec4899',
          floating_cta_text_color: '#ffffff'
        };
      }
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
};
